<template>
  <div id="app">
    <Navigation></Navigation>
    <ActiveAlertBanner v-if="is_authenticated"></ActiveAlertBanner>
    <Notifications></Notifications>
    <div class="container my-1" style="max-width: 96%">
      <Infobar></Infobar>
      <router-view v-if="is_authenticated"></router-view>
      <div v-else>
        <router-view name="non_authenticated"></router-view>
      </div>
      <hr>
      <p>&copy; {{ current_year }} - Galaxy Next Generation (G2) |
        <router-link :to="{ name: 'License' }">View License</router-link>
        | Version: {{ version }}
      </p>
    </div>
    <Modal :modal_id="'queryModal'">
      <template v-slot:title>
        What can I help you find?
      </template>
      <template v-slot:body>
        <form @submit="find_intent()">
          <input id="txtSearchQuery" type="text" class="form-control" v-model="search" />
          <button type="submit" class="btn btn-hub-primary">Find</button>
        </form>
      </template>
    </Modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import 'bootstrap'
import './assets/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import './assets/css/style.css'
import ActiveAlertBanner from './components/AppWide/ActiveAlertBanner'
import Navigation from './components/AppWide/Navigation'
import Notifications from './components/AppWide/Notifications'
import Infobar from './components/AppWide/Infobar'
import Modal from './components/Modal'

export default {
  components: { Navigation, Notifications, Infobar, ActiveAlertBanner, Modal },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    ...mapGetters({
      current_year: 'currentYear',
      is_authenticated: 'isAuthenticated',
      version: 'version'
    })
  },
  methods: {
    is_active_alert() {
      this.$store.dispatch('getActiveAlertEvent')
    },
    find_intent () {
      this.$store.dispatch('findIntent', this.search)
      $('#queryModal').modal('hide');
      this.search = ''
    },
  },
  watch: {
    is_authenticated: {
      handler(isAuth) {
        if(isAuth === false) {
          clearInterval(this.interval);
        } else {
          this.is_active_alert()
          this.interval = setInterval(() => {
            this.is_active_alert()
          }, 3000)
        }
      },
      immediate: true
    }
  },
  created () {
    this.$store.dispatch('isAuthenticated')
    this.$store.dispatch('getMachineType')
    this.$store.dispatch('getVersion')

    window.addEventListener('keydown', (e) => {
      if (e.ctrlKey && e.shiftKey && e.keyCode === 83) {
        e.preventDefault();
        $('#queryModal').modal('show');

        setTimeout(() => {
          document.getElementById('txtSearchQuery').focus()
        }, 500)
      }
    });
  }
}
</script>
